<div class='snackbar-wrap'>
  <div>
    {{ config.type | titlecase }}
  </div>

  <div [ngSwitch]='config.type' class='content-style'>
    <div *ngSwitchCase="'error'">
      <div
        *ngIf='config.message.code; else noCode'
        [ngSwitch]='config.message.code'>
        <div *ngSwitchCase='0'>Unauthorized action!</div>
        <div *ngSwitchCase='1002'>
          <div *ngIf="checkType(config.message.message, 'array')">
            test
            <p *ngFor='let message of config.message.message'>{{ message }}</p>
          </div>
          <div *ngIf="checkType(config.message.message, 'object')">
            <p *ngFor='let item of config.message.message | keyvalue'>
              {{ renderStringMessage(item.value.toString()) }}
            </p>
          </div>
          <div *ngIf="checkType(config.message.message, 'string')">
            test 3
            <p>{{ renderStringMessage(config.message.message) }}</p>
          </div>
        </div>
        <div *ngSwitchDefault>
          <div *ngIf="checkType(config.message.message, 'array')">
            <p *ngFor='let message of config.message.message'>{{ message }}</p>
          </div>
          <div *ngIf="checkType(config.message.message, 'object')">
            <p *ngFor='let item of config.message.message | keyvalue'>
              {{ item.value }}
            </p>
          </div>
          <div *ngIf="checkType(config.message.message, 'string')">
            <p>{{ config.message.message }}</p>
          </div>
        </div>
      </div>
      <ng-template #noCode>
        <div *ngIf="checkType(config.message, 'string')">
          <p>{{ config.message }}</p>
        </div>
        <div *ngIf='isArray(config.message.message)'>
          <p *ngFor='let message of config.message.message'>{{ message }}</p>
        </div>
      </ng-template>
    </div>

    <div *ngSwitchCase="'success'">
      {{ config.message }}
    </div>
    <div *ngSwitchCase="'warning'">
      {{ config.message }}
    </div>
  </div>

  <div *ngIf='config.button' style='text-align: center'>
    <button (click)='onButtonClicked()' mat-flat-button>
      {{ config.button.text }}
    </button>
  </div>
</div>
